import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiredRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles 
}) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  if (!isAuthenticated) {
    // Redirect to login with return URL
    // Store redirect path in both sessionStorage and localStorage as backup (in case state is lost)
    if (location.pathname !== '/login') {
      const redirectPath = location.pathname + location.search + location.hash;
      sessionStorage.setItem('keycloak_redirect_path', redirectPath);
      localStorage.setItem('keycloak_redirect_path', redirectPath);
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check roles if required
  if (requiredRoles && requiredRoles.length > 0) {
    // Note: Role checking would require extracting roles from JWT token
    // For now, we'll skip role-based checks in Iteration 1
    // This can be enhanced in later iterations
  }

  return children;
};

